import { AvTimer, LinkedIn, LinkSharp } from '@mui/icons-material'
import { Avatar, Box, Button, Typography } from '@mui/material'
import { Variants, motion } from 'framer-motion'
import "@fontsource/roboto"; // Defaults to weight 400
import "@fontsource/roboto/400.css"; // Specify weight
import "@fontsource/roboto/400-italic.css"; // Specify weight and style
import { useTranslation } from 'react-i18next';
import { useNavigate } from 'react-router-dom';

interface Props { }

function Project(props: { icon?: any, smallImale? : true, buttonName? :string, withBackground?: true, gap? :true, boxShadow?: true, fullWidthImage?: true, withFont?: true, logo: string, title: string, description: string, link: string, linkName: string, date: string, showBtn?: true }) {
    const { } = props
    const { t, i18n } = useTranslation();
    const navigate = useNavigate()
    const scroll: Variants = {
        offscreen: {
            y: 15,
            opacity: .5
        },
        onscreen: {
            y: 10,
            opacity: 1,
            transition: {
                bounce: 0.6,
                duration: 1
            }
        }
    };

    return (
        <>
            <div className='project' style={{ backgroundColor: props.withBackground? "white": "none", width: props.gap? "90%": "100%", boxShadow: props.boxShadow? "0px 1px 20px 1px rgba(107, 91, 195, .1)": "none" }} >

                <center>
                    <motion.div
                        initial="offscreen"
                        whileInView="onscreen"
                        viewport={{ once: false, amount: 0.8 }}
                        variants={scroll}
                    >
                        <img style={{ borderRadius: "10px" }} width={props.smallImale? "50%": "90%"} height={props.smallImale? "none": "200px"} src={props.logo} alt="" />
                    </motion.div>
                    <motion.div
                        initial="offscreen"
                        whileInView="onscreen"
                        viewport={{ once: false, amount: 0.8 }}
                        variants={scroll}
                    ><Typography color={props.withFont? "white": "inherit"} variant='h6'>
                            {props.title}
                        </Typography>
                    </motion.div>
                    <br />
                    <motion.div
                    style={{marginLeft: "5%", marginRight: "5%"}}
                        initial="offscreen"
                        whileInView="onscreen"
                        viewport={{ once: false, amount: 0.8 }}
                        variants={scroll}
                    ><label className='descriptionP' style={{   color: props.withFont? "white": "inherit", fontWeight: "lighter" }}>
                            {props.description}
                        </label></motion.div>
                    <br />
                    {props.showBtn ?
                        <motion.div
                            initial="offscreen"
                            whileInView="onscreen"
                            viewport={{ once: false, amount: 0.8 }}
                            variants={scroll}
                        ><button className="btn" onClick={(event) => {

                            navigate(props.link)
                            const anchor = (
                                (event.target as HTMLDivElement).ownerDocument || document
                            ).querySelector('#back-to-top-anchor');

                            if (anchor) {
                                anchor.scrollIntoView({
                                    block: 'center',
                                });
                            };
                        }}> {props.icon} {props.buttonName? props.buttonName : t("Label.Titre.titre9")}</button></motion.div>

                        : ""}
                    {/* {t("voir-la-certif")} */}
                    <br />
                </center>
            </div>
            <br />
        </>
    )
}

export default Project
